<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="xl:col-6 md:col-6 col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="template.name"
              [isError]="$any(errors?.name)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error"
              >{{ errors.name | join }}</small
            >
          </div>

          <div class="field-checkbox mb-0 col-12">
            <p-checkbox
              [(ngModel)]="template.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Неактивный</label>
          </div>
        </div>
      </p-card>

      <p-card
        header="Детали"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Компания</label>
            <crm-single-select
              [options]="companies"
              [(selectedItem)]="template.company"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              (selectedItemChange)="changeCompany()"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.company"
              class="p-error"
              >{{ errors.company | join }}</small
            >
          </div>

          <div class="field col-12">
            <label class="font-medium">Валюта</label>
            <crm-currency-single-select
              [currencies]="currencies"
              [(selectedCurrency)]="template.currency"
              [customSearch]="true"
              [disabled]="!template.company"
              [isError]="$any(errors?.currency)"
              appendTo="body"></crm-currency-single-select>
            <small
              *ngIf="errors?.currency"
              class="p-error">
              {{ errors.currency | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Сумма</label>
            <p-inputNumber
              [(ngModel)]="template.amount"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"
              styleClass="w-full"
              class="w-full"></p-inputNumber>
            <small
              *ngIf="errors?.amount"
              class="p-error"
              >{{ errors.amount | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="template.contragent"
              styleClass="w-full"
              class="w-full"
              inputStyleClass="w-full"
              appendTo="body"
              [customSearch]="false"
              [isError]="$any(errors?.contragent)"></crm-contragent-auto-complete>
            <small
              *ngIf="errors?.contragent"
              class="p-error"
              >{{ errors.contragent | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Вид операции</label>
            <crm-operation-type-single-select
              [(selectedOperationType)]="template.operationType"
              [isError]="$any(errors?.operationType)"
              appendTo="body"></crm-operation-type-single-select>
            <small
              *ngIf="errors?.operationType"
              class="p-error"
              >{{ errors.operationType | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Тип документа</label>
            <crm-document-type-single-select
              [(selectedDocumentType)]="template.type"
              [isError]="$any(errors?.type)"
              [showClear]="false"
              appendTo="body"></crm-document-type-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired">
              Филиал
            </label>
            <crm-filial-single-select
              [(selectedFilial)]="template.filial"
              [isError]="$any(errors?.filial)"
              appendTo="body"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error"
              >{{ errors.filial | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired">
              Бизнес единица
            </label>
            <crm-unit-single-select
              [(selectedUnit)]="template.unit"
              [isError]="$any(errors?.unit)"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error"
              >{{ errors.unit | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label
              class="font-medium"
              [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired"
              >Бюджетная статья</label
            >
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="template.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error"
              >{{ errors.direction | join }}</small
            >
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Сделка</label>
            <crm-deal-auto-complete
              [(selectedDeal)]="template.deal"
              [isError]="$any(errors?.deal)"
              styleClass="w-full"
              inputStyleClass="w-full"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error"
              >{{ errors.deal | join }}</small
            >
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Действует до</label>
            <crm-datepicker
              [(value)]="template.activeUntil"
              (valueChange)="template.disabled = false"
              [inputStyleClass]="errors?.activeUntil ? 'ng-invalid ng-dirty' : ''"
              [minDate]="today"
              styleClass="w-full"></crm-datepicker>
            <small
              *ngIf="errors?.activeUntil"
              class="p-error">
              {{ errors.activeUntil | join }}
            </small>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Центр затрат</label>
            <crm-cost-center-single-select
              [(selectedCostCenter)]="template.costCenter"
              [isError]="$any(errors?.costCenter)"
              appendTo="body"></crm-cost-center-single-select>
            <small
              *ngIf="errors?.costCenter"
              class="p-error">
              {{ errors.costCenter | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Комментарий</label>
            <crm-template-subject-editor [(value)]="template.commentary"></crm-template-subject-editor>
            <small
              *ngIf="errors?.commentary"
              class="p-error"
              >{{ errors.commentary | join }}</small
            >
          </div>

          <div class="field col-12">
            <h3 class="font-medium -mb-2">Планирование дедлайна</h3>
            <p-divider></p-divider>
            <crm-planning-deadline-form
              [planning]="template.deadline"
              [errors]="$any(errors?.deadline)"></crm-planning-deadline-form>
          </div>
        </div>
      </p-card>
    </div>

    <div class="xl:col-6 md:col-6 col-12">
      <crm-planning-periodicity-card
        [planning]="template.planning"
        [errors]="$any(errors?.planning)"></crm-planning-periodicity-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="xl:col-6 md:col-6 col-12 flex flex-wrap justify-content-between">
      <div>
        <button
          pButton
          [label]="saveButtonLabel"
          class="p-button-success mr-2"
          (click)="saveTemplate()"></button>
      </div>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        [label]="'Удалить'"
        class="p-button-danger p-button-text"
        (click)="deleteTemplate()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
